module.exports = __webpack_public_path__ + "assets/img/media_26.706416b1.png";